import Typography from '@mui/material/Typography';

export function ErrorFallback() {
  return <Typography padding={2}>Oops, something went wrong!</Typography>;
}

export default ErrorFallback;
